import {
  path,
  pathOr,
  pipe,
  replace,
  ifElse,
  is,
  groupBy,
  prop,
  toPairs,
  map,
  sum,
  defaultTo,
  filter,
  propOr,
  toLower,
  find,
  equals,
  pathEq,
} from 'ramda';

export const getValueField = pathOr(null, ['tags', 'valueField', 0]);
export const getRegionField = path(['tags', 'regionField', 0]);
export const getCategoryField = pathOr(null, ['tags', 'categoryField', 0]);

export const parseNumber = number =>
  ifElse(
    is(String),
    pipe(replace(/,/g, ''), replace(/-/g, '0'), number => parseInt(number, 10)),
    defaultTo(0)
  )(number);

export const getSummedData = ({ data, groupByField, valueField }) =>
  pipe(
    groupBy(prop(groupByField)),
    toPairs,
    map(([region, array]) => ({
      [groupByField]: region,
      [valueField]: valueField ? pipe(map(pipe(prop(valueField), parseNumber)), sum)(array) : array.length,
    }))
  )(data);

export const getMultiSeriesData = ({ data, selectedFilters, groupByField, regionField, valueField }) =>
  pipe(
    filter(data => selectedFilters.includes(data[regionField])),
    groupBy(prop(groupByField)),
    toPairs,
    map(([region, array]) => ({
      [groupByField]: region,
      ...array.reduce(
        (prev, next) => ({
          ...prev,
          [next[regionField]]: parseNumber(next[valueField]) + propOr(0, next[regionField], prev),
        }),
        {}
      ),
    }))
  )(data);

export const formatToKebabCase = pipe(toLower, replace(/ /g, '-'), replace(/[()]/g, ''));

const getTopic = ({ topic, topics }) => {
  if (topic) {
    return find(pipe(prop('topic'), formatToKebabCase, equals(topic)), topics);
  }

  return find(pipe(prop('dataSources'), find(pathEq(['meta', 'customData', 'default'], 'true'))))(topics);
};

const getSubtopic = ({ topicDataSources, subtopic }) => {
  if (subtopic) {
    return find(pipe(path(['meta', 'customData', 'subtopic']), formatToKebabCase, equals(subtopic)))(topicDataSources);
  }

  return find(pipe(path(['meta', 'customData', 'defaultSubtopic']), equals('true')))(topicDataSources);
};

export const getRegionData = ({ topic, subtopic, dataSourcesFilterByRegion }) => {
  const topics = pipe(
    groupBy(path(['tags', 'topics'])),
    toPairs,
    map(([topic, dataSources]) => ({ topic, dataSources }))
  )(dataSourcesFilterByRegion);

  const defaultTopic = getTopic({ topic, topics }) || topics[0];
  const topicDataSources = propOr([], 'dataSources', defaultTopic);

  const defaultSubtopic = getSubtopic({ subtopic, topicDataSources }) || topicDataSources[0];

  return { topics, defaultTopic, defaultSubtopic };
};
